import React, { Component } from 'react'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import IconButton from 'material-ui/IconButton'
import Snackbar from 'material-ui/Snackbar'
import Clear from 'material-ui/svg-icons/content/clear'
import { FormattedMessage } from 'react-intl'
import CreateNewSeminarForm from '../../../components/Seminars/CreateNewSeminarForm'
import { getToken } from '../../../lib'
import { ALertHeaderText, ConfirmText } from '../../../components/Seminars/SeminarActions/styles'

const UpgradeAccount = ({handleClose, handleUpgrade}) => (
  <div>
    <div className='flex justify-between items-center'>
      <ALertHeaderText>
        <FormattedMessage id='loggedInNavigation.modalHeader'/>
      </ALertHeaderText>
      <div>
        <IconButton onTouchTap={handleClose} iconStyle={{fill: '#afb8c5'}}>
          <Clear/>
        </IconButton>
      </div>
    </div>
    <ConfirmText className='mt3 mb3'>
      <FormattedMessage id='loggedInNavigation.upgradeConfirmation'/>
    </ConfirmText>
    <div
      className='mb3'
      style={{fontSize: 20, color: 'rgba(50, 50, 93, 0.7)'}}>
      <FormattedMessage id='loggedInNavigation.upgradeModalBody'/>
    </div>
    <div className='flex justify-end'>
      <div className='w4'>
        <FlatButton
          label={<FormattedMessage id='loggedInNavigation.cancel'/>}
          fullWidth
          labelStyle={{color: '#AFB8C4'}}
          onTouchTap={handleClose}
        />
      </div>
      <div className='ml2 w6'>
        <FlatButton
          label={<FormattedMessage id='loggedInNavigation.upgrade'/>}
          fullWidth
          backgroundColor='#29B87A'
          hoverColor='#1e8257'
          labelStyle={{color: '#FFFFFF'}}
          onTouchTap={handleUpgrade}
        />
      </div>
    </div>
  </div>
)

export default class Modal extends Component {
  constructor (props) {
    super(props)

    this.state = {
      open: false,
      snackbarOpen: false,
      snackbarSecondOpen: false
    }
  }

  upGradeAndRefreshUser = (upgrade, callback) => {

  }

  handleOpen = () => this.setState({open: true})
  handleClose = () => this.setState({open: false})
  handleUpgrade = () => {
    const token = getToken()
    if (!this.props.newSeminar) {
      this.props.upgradeUser(token, this.props.user.id, 'free_admin')
      return this.setState({open: false, snackbarOpen: true, snackbarSecondOpen: true})
    }
  }

  handleRequestClose = () => this.setState({snackbarOpen: false})
  handleSecondRequestClose = () => this.setState({snackbarSecondOpen: false})

  render () {
    return (
      <div>
        <Dialog
          modal
          contentStyle={{width: (this.props.guest) ? 430 : '25vw'}}
          open={this.state.open}
          onRequestClose={this.handleClose}>
          {(!this.props.newSeminar) ? (
            <UpgradeAccount handleUpgrade={this.handleUpgrade} handleClose={this.handleClose}/>
          ) : (
            <CreateNewSeminarForm
              createConference={this.props.createConference}
              handleClose={this.handleClose}/>
          )}
        </Dialog>
        {false && <Snackbar
          style={{left: 200, bottom: 100}}
          open={this.state.snackbarSecondOpen}
          message='check email for verification'
          action='dismiss'
          onActionTouchTap={this.handleSecondRequestClose}
          autoHideDuration={4000}
          onRequestClose={this.handleSecondRequestClose}
        />}
        {false && <Snackbar
          style={{left: 200, bottom: 30}}
          open={this.state.snackbarOpen}
          message='Your account is upgraded to admin'
          action='dismiss'
          onActionTouchTap={this.handleRequestClose}
          autoHideDuration={4000}
          onRequestClose={this.handleRequestClose}
        />}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/LoggedIn/Modal/Modal.js